function Layout({ children }) {
  return (
    <div className="lmf__container">
      <div className="lmf__wrapper">{children}</div>
    </div>
  );
}

export default Layout;
